
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FirmWareInfoActions, FirmWareInfoActionTypes } from '../actions/firm-ware-info.actions';
import { FirmWareInfo } from '../firm-ware.model';

export interface State extends EntityState<FirmWareInfo> {
  Loaded: boolean;
  Loading: boolean;
  // entities: FirmWareInfo[];
}

export const adapter: EntityAdapter<FirmWareInfo> = createEntityAdapter<FirmWareInfo>({
  selectId: info => info.Id
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: FirmWareInfoActions): State {
  switch (action.type) {
    case FirmWareInfoActionTypes.GetFirmWares:
      return {...state, Loaded: false, Loading: true};

    case FirmWareInfoActionTypes.GetFirmwareInfo:
      return {...state, Loaded: false, Loading: true};

    case FirmWareInfoActionTypes.GetFirmwareList:
      return {...state, Loaded: false, Loading: true};

    case FirmWareInfoActionTypes.LoadFirmWares:
      return adapter.upsertMany(action.payload, {...state, Loaded: true, Loading: false});

    case FirmWareInfoActionTypes.GetFirmWaresFail:
      return {...state, Loaded: true, Loading: false};

    case FirmWareInfoActionTypes.LoadFirmwareInfo:
      return adapter.upsertOne(action.payload, {...state, Loaded: true, Loading: false});

    case FirmWareInfoActionTypes.GetFirmwareInfoFail:
      return {...state, Loaded: true, Loading: false};

    case FirmWareInfoActionTypes.LoadFirmwareList:
      return adapter.upsertMany(action.payload, {...state, Loaded: true, Loading: false});

    case FirmWareInfoActionTypes.GetFirmwareListFail:
      return {...state, Loaded: true, Loading: false};

    case FirmWareInfoActionTypes.GetAddFirmwareInfo:
      return {...state, Loaded: false, Loading: true};

    case FirmWareInfoActionTypes.AddFirmwareInfo:
      return adapter.addOne(action.payload, {...state, Loaded: true, Loading: false});

    case FirmWareInfoActionTypes.AddFirmwareInfoFail:
      return {...state, Loaded: true, Loading: false};

    case FirmWareInfoActionTypes.GetUpdateFirmwareInfo:
      return {...state, Loaded: false, Loading: true};

    case FirmWareInfoActionTypes.UpdateFirmwareInfo:
      return adapter.updateOne(action.payload.module, state);

    case FirmWareInfoActionTypes.UpdateFirmwareInfoFail:
      return {...state, Loaded: true, Loading: false};

    case FirmWareInfoActionTypes.GetReleaseFirmwareInfo:
      return {...state, Loaded: false, Loading: true};

    case FirmWareInfoActionTypes.ReleaseFirmwareInfo:
      return adapter.updateOne(action.payload.module, state);

    case FirmWareInfoActionTypes.ReleaseFirmwareInfoFail:
      return {...state, Loaded: true, Loading: false};

    default:
      return state;
  }
}
